/************************************
MODULE:         TABS
WHAT IT DOES:   Detects tabs modules, gets all tabs parametrs, send tabs to initialization
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {

    function init() {
        iniTabsGlobal();
        initTabsLinks();
        $(window).off('tabs:init');
        $(window).on('tabs:init', iniTabsGlobal);
        $(window).on('tabs:init', initTabsLinks);
    }

    function initTabsLinks() {
        var tabLinks = $('.js-tab-link');
        tabLinks.off('click.customtab');
        tabLinks.on('click.customtab', tabLinkClick);
    }

    function tabLinkClick(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var tabId = $(this).attr('data-tab-id-link');
        if (!tabId) return;

        $('a[data-tab-id="' + tabId + '"]').click();
    }

    function iniTabsGlobal() {
        var tabs = $('.js-tabs').not('.js-inited');
        if (!tabs.length) {
            return;
        }
        initTabs(tabs);
    }

    function initTabs(tabs) {
        require.ensure([], function () {
        var generictab = require('generic.tab');
        tabs.addClass('js-inited');
        for (var i = 0, l = tabs.length; i < l; i++) {
            var tabEl = tabs.eq(i),
                options = {},
                tabOptions = {},
                defaultTab;

            options['horizontalPosition'] = tabEl.attr('data-horizontal-position');
            options['carouseled'] = tabEl.attr('data-carouseled');
            options['theme'] = tabEl.attr('data-tabs-theme');
            options['effect'] = tabEl.attr('data-effect');

            defaultTab = tabEl.attr('data-defaulttab');
            if (defaultTab)
                options['defaultTab'] = defaultTab;

            for (var option in options) {
                if (options[option])
                    tabOptions[option] = options[option];
            }

            new generictab(tabs.eq(i), tabOptions);
        }
   }, 'tab');
    }

    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.tabs.js
 ** module id = 64
 ** module chunks = 24
 **/